import { type ForwardedRef, forwardRef, memo, useMemo } from 'react';

import { type SanitizeSchema, transformHtmlToHast } from '@didaskill/domain/html';

import { HastRenderer, type HastRendererProps } from '../hast-renderer/HastRenderer';

export type HtmlRendererProps = Omit<HastRendererProps, 'hast'> & {
  html?: string;
  sanitizeSchema: SanitizeSchema;
};

export const HtmlRendererBase = forwardRef(
  (
    { html = '', sanitizeSchema, ...props }: HtmlRendererProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const hast = useMemo(
      () => transformHtmlToHast(html, { sanitizeSchema }),
      [html, sanitizeSchema],
    );

    return <HastRenderer {...props} ref={ref} hast={hast} />;
  },
);

HtmlRendererBase.displayName = 'HtmlRenderer';

export const HtmlRenderer = memo(HtmlRendererBase);
